import type { ReactNode } from 'react'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { CrossIcon } from 'ui/src/icons/CrossIcon'
import { dialogContent, dialogClose, iframe } from './PDFViewer.css'

type Props = {
  url: string
  children: ReactNode
}

export function PDFViewer({ children, url }: Props) {
  const encodedUrl = encodeURIComponent(url)

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild={true}>{children}</Dialog.Trigger>
      <Dialog.Content className={dialogContent}>
        <Dialog.Close className={dialogClose}>
          <CrossIcon />
        </Dialog.Close>
        <iframe className={iframe} src={`/pdfjs/web/viewer.html?file=${encodedUrl}`} />
      </Dialog.Content>
    </Dialog.Root>
  )
}
